import { render, staticRenderFns } from "./ProductFormPage.vue?vue&type=template&id=1e4a5062&scoped=true"
import script from "./ProductFormPage.vue?vue&type=script&lang=js"
export * from "./ProductFormPage.vue?vue&type=script&lang=js"
import style0 from "./ProductFormPage.vue?vue&type=style&index=0&id=1e4a5062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a5062",
  null
  
)

export default component.exports